import React from "react";
import { useTranslation } from "react-i18next";
import meta_data from "../data/meta_data.json";

const Timestamp = () => {
  const { t } = useTranslation();
  return (
    <p className="text-sm text-secondary">
      {t("last updated")} {meta_data.last_update}
    </p>
  );
};

export default Timestamp;
